var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';
var Mapbox = /** @class */ (function (_super) {
    __extends(Mapbox, _super);
    function Mapbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Mapbox.prototype.mounted = function () {
        // Initialze Map
        this.map = this.mapInit();
        // Add Controls to map
        this.addControls(this.map);
        // Register Map Events
        this.registerMapEvents(this.map);
    };
    Mapbox.prototype.beforeDestroy = function () {
        this.map.remove();
    };
    Mapbox.prototype.mapInit = function () {
        mapboxgl.accessToken = this.accessToken;
        // Add container to options object
        if (!Object.prototype.hasOwnProperty.call(this.mapOptions, 'container')) {
            this.mapOptions.container = 'map';
        }
        // New Mapbox Instance
        var map = new mapboxgl.Map(this.mapOptions);
        return map;
    };
    Mapbox.prototype.registerMapEvents = function (map) {
        var _this = this;
        var availableEvents = [
            'error',
            'load',
            'remove',
            'render',
            'resize',
            'webglcontextlost',
            'webglcontextrestored',
            'dataloading',
            'data',
            'tiledataloading',
            'sourcedataloading',
            'styledataloading',
            'sourcedata',
            'styledata',
            'boxzoomcancel',
            'boxzoomstart',
            'boxzoomend',
            'touchcancel',
            'touchmove',
            'touchend',
            'touchstart',
            'click',
            'contextmenu',
            'dblclick',
            'mousemove',
            'mouseup',
            'mousedown',
            'mouseout',
            'mouseover',
            'mouseenter',
            'mouseleave',
            'movestart',
            'move',
            'moveend',
            'zoomstart',
            'zoom',
            'zoomend',
            'rotatestart',
            'rotate',
            'rotateend',
            'dragstart',
            'drag',
            'dragend',
            'pitchstart',
            'pitch',
            'pitchend',
            'wheel',
        ];
        var availableEventsWithLayerSupport = [
            'touchcancel',
            'touchend',
            'touchstart',
            'click',
            'contextmenu',
            'dblclick',
            'mousemove',
            'mouseup',
            'mousedown',
            'mouseout',
            'mouseover',
            'mouseenter',
            'mouseleave',
        ];
        if (Object.keys(this.$listeners).length) {
            var _loop_1 = function (eventType) {
                var _a = eventType
                    .replace(/^map-/, '')
                    .split(':'), parsedEventType = _a[0], layerId = _a[1];
                if (availableEvents.indexOf(parsedEventType) > -1) {
                    if (layerId &&
                        availableEventsWithLayerSupport.indexOf(parsedEventType) > -1) {
                        map.on(parsedEventType, layerId, function (event) {
                            _this.$emit(eventType, map, event);
                        });
                    }
                    else {
                        map.on(parsedEventType, function (event) {
                            _this.$emit(eventType, map, event);
                        });
                    }
                }
            };
            for (var eventType in this.$listeners) {
                _loop_1(eventType);
            }
        }
    };
    Mapbox.prototype.addControls = function (map) {
        var _this = this;
        // Nav Control
        if (this.navControl.show) {
            var nav = new mapboxgl.NavigationControl(this.navControl.options);
            map.addControl(nav, this.navControl.position);
        }
        // Geolocation Control
        if (this.geolocateControl.show) {
            var geolocate_1 = new mapboxgl.GeolocateControl(this.geolocateControl.options);
            map.addControl(geolocate_1, this.geolocateControl.position);
            var availableEvents = [
                'error',
                'trackuserlocationstart',
                'trackuserlocationend',
                'geolocate',
            ];
            if (Object.keys(this.$listeners).length) {
                var _loop_2 = function (eventType) {
                    var parsedEventType = eventType.replace(/^geolocate-/, '');
                    if (availableEvents.indexOf(parsedEventType) > -1) {
                        geolocate_1.on(parsedEventType, function (position) {
                            if (position) {
                                _this.$emit(eventType, geolocate_1, position);
                            }
                            else {
                                _this.$emit(eventType, geolocate_1);
                            }
                        });
                    }
                };
                for (var eventType in this.$listeners) {
                    _loop_2(eventType);
                }
            }
        }
        // Scale Control
        if (this.scaleControl.show) {
            var scale = new mapboxgl.ScaleControl(this.scaleControl.options);
            map.addControl(scale, this.scaleControl.position);
        }
        // Fullscreen Control
        if (this.fullscreenControl.show) {
            var fullscreen = new mapboxgl.FullscreenControl();
            map.addControl(fullscreen, this.fullscreenControl.position);
        }
    };
    __decorate([
        Prop({ required: true })
    ], Mapbox.prototype, "accessToken", void 0);
    __decorate([
        Prop({ required: true })
    ], Mapbox.prototype, "mapOptions", void 0);
    __decorate([
        Prop({
            default: function () {
                return {
                    show: true,
                    position: 'top-right',
                    options: {},
                };
            },
        })
    ], Mapbox.prototype, "navControl", void 0);
    __decorate([
        Prop({
            default: function () {
                return {
                    show: false,
                    position: 'top-left',
                    options: {},
                };
            },
        })
    ], Mapbox.prototype, "geolocateControl", void 0);
    __decorate([
        Prop({
            default: function () {
                return {
                    show: false,
                    position: 'top-left',
                    options: {},
                };
            },
        })
    ], Mapbox.prototype, "scaleControl", void 0);
    __decorate([
        Prop({
            default: function () {
                return {
                    show: false,
                    position: 'top-right',
                    options: {},
                };
            },
        })
    ], Mapbox.prototype, "fullscreenControl", void 0);
    __decorate([
        Prop({
            default: function () {
                return {
                    show: false,
                    position: 'top-right',
                    options: {},
                };
            },
        })
    ], Mapbox.prototype, "attributionControl", void 0);
    __decorate([
        Emit()
    ], Mapbox.prototype, "mapInit", null);
    Mapbox = __decorate([
        Component
    ], Mapbox);
    return Mapbox;
}(Vue));
export default Mapbox;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/mapbox-gl-vue/src/Mapbox.vue
// module id = null
// module chunks = 